import { KpiReport, KpiReportEntity } from "./kpiReport.types";

export const getKpiReportFromGQResult = (entities?: KpiReportEntity[]): KpiReport[] => {
    return (entities ?? []).map(({ provider, ...rest }) => {
        return {
            provider: provider.entity,
            ...rest
        };
    });
};
